import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(5.11vw, 73px) min(12.46vw, 178px);
  align-items: center;
  background-color: #ffffff;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  h1 {
    font-size: min(4.2vw, 60px);
    line-height: min(4.2vw, 60px);

    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(1.26vw, 18px);
    text-align: center;
    
  }
  h2 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(1.26vw, 18px);
    color: #095587;
    text-align: center;
    max-width: min(1036px,72vw);

  }
  img {
    width: min(62.44vw, 892px);
    max-width: 100%;
  }
  @media (max-width: 767px) {
        padding: min(5.11vw,73px) min(9.73vw,139px);
    h1 {
      /* font-size: 4.7vw; */
      line-height: 4vw;
      margin-bottom: 2.42vw;
    }
    h2 {
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
      max-width: 100%;

    }
    img {
      width: min(81.44vw, 892px);
      max-width: 100%;
    }
  }
`;

export { Container, Wrapper };
